import React from 'react';
import { Grid } from '@mui/material';

import AuthContainer from 'components/AuthContainer';
import TopSection from 'components/TopSection/TopSection';
import StyledActivities from './Feedbacks.styles';
import FeedbackList from './components/FeedbacksList/FeedbacksList';

const Feedbacks: React.FC = () => {
  return (
    <AuthContainer>
      <TopSection title="Feedbacks" hideFilter />
      <StyledActivities>
        <Grid container spacing={2}>
            <FeedbackList />
        </Grid>
      </StyledActivities>
    </AuthContainer>
  );
};

export default Feedbacks;
